/* eslint-disable @typescript-eslint/no-shadow */
import { LanguageViewModel } from '@/entities/LanguageViewModel';
import LanguageTypeEnum from '@/enums/LanguageTypeEnum';
import { t } from '@/main';

export default class TemplateLanguageViewModel {
  public TemplateLanguageViewModel: LanguageViewModel[] = [];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor() {
    this.TemplateLanguageViewModel.push({ Id: LanguageTypeEnum.English, Label: t('Language.English').toString()});
    this.TemplateLanguageViewModel.push({ Id: LanguageTypeEnum.Swedish, Label: t('Language.Swedish').toString()});
  }
}
